<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('actiontype_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-actiontype-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.namefr') }}</strong></td>
              <td>
                {{ item['namefr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.statuschange') }}</strong></td>
              <td>
                                    {{ item['status'] }}
              </td>
              <td><strong>{{ $t('ticket.public') }}</strong></td>
              <td>
                                    {{ item['public'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.hub') }}</strong></td>
              <td>
                                    {{ item['hubCreated'] }}
              </td>
              <td><strong>{{ $t('ticket.response') }}</strong></td>
              <td>
                                    {{ item['response'] }}
              </td>
            </tr>
            
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Actiontype';

export default {
  name: 'ActiontypeShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('actiontype', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('actiontype', ['find'])
  },
  methods: {
    ...mapActions('actiontype', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
